import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {BookingCategoryDto} from "../booking-category.dto";

export class SearchBookingCategoryRes extends SearchResultDto {

  public override readonly items: SearchBookingCategoryItem[] = [];

  constructor(init?: Partial<SearchBookingCategoryRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchBookingCategoryItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchBookingCategoryItem extends BookingCategoryDto implements SearchItem {

  constructor(init?: Partial<SearchBookingCategoryItem>) {
    super(init);
    Object.assign(this, init);
  }
}
